"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_NAME_LENGTH = exports.getFolderById = exports.ROOT_ID = exports.PERSONAL_FOLDER_ID = exports.findFolderByResourceId = exports.getFoldersBySbId = exports.checkUserPermission = exports.getCardNamesForBulkCopy = exports.getSelectedFolderTree = exports.getUniqueName = exports.isResourceCopiedNameExist = exports.getSBFoldersNavList = exports.getInitialLocationValue = exports.buildSbFoldersTree = exports.buildFolderTree = exports.hasContextConflictTerms = void 0;
const get_1 = __importDefault(require("lodash/get"));
const sortBy_1 = __importDefault(require("lodash/sortBy"));
const ROOT_ID = 'root';
exports.ROOT_ID = ROOT_ID;
const PERSONAL_FOLDER_ID = 0; // Todo check if we want move all those utils from appem to here.
exports.PERSONAL_FOLDER_ID = PERSONAL_FOLDER_ID;
const CONFLICT_QUERY_TERMS = [
    'campaign_targeted_by',
    'campaign_not_targeted_by',
    'campaign_converted_by',
    'campaign_not_converted_by',
    'successplay_targeted_by',
    'successplay_not_targeted_by',
];
const findFolderByResourceId = (resourceId, resourceType, folders) => {
    const folder = folders.find((f) => f.resources.find((r) => r.resource_type === resourceType && r.resource_id === resourceId.toString()));
    return folder ? folder.id : ROOT_ID;
};
exports.findFolderByResourceId = findFolderByResourceId;
const getFolderById = (folders, folderId) => folders.find(({ id }) => `${id}` === `${folderId}`);
exports.getFolderById = getFolderById;
const getFoldersNavList = (folders, currentId, foldersList, options = { rootId: ROOT_ID, parentIdName: 'parent_id' }) => {
    if (currentId === options.rootId) {
        return foldersList;
    }
    const currentFolder = getFolderById(folders, currentId);
    if (!currentFolder) {
        return foldersList;
    }
    foldersList.unshift(currentFolder);
    const parentId = currentFolder[options.parentIdName];
    if (parentId === options.rootId || !parentId || parentId === currentFolder.id) {
        return foldersList;
    }
    return getFoldersNavList(folders, parentId, foldersList, options);
};
const hasContextConflictTerms = (terms) => !!terms.find((f) => CONFLICT_QUERY_TERMS.includes(f.query_term_id)
    || (f.type === 'parent_account' && hasContextConflictTerms(f.terms)));
exports.hasContextConflictTerms = hasContextConflictTerms;
const itemsForTreeReducer = (parentIdKey, keyPrefix, items, currentItem) => {
    const newItems = { ...items };
    const parentId = currentItem[parentIdKey];
    if (!newItems[parentId]) {
        newItems[parentId] = { icon: 'folder', items: [] };
    }
    if (!newItems[currentItem.id]) {
        newItems[currentItem.id] = { icon: 'folder', items: [] };
    }
    const item = newItems[currentItem.id];
    item.key = keyPrefix ? `${keyPrefix}${currentItem.id}` : currentItem.id;
    item.value = currentItem.name;
    item.sbId = currentItem.sb_id;
    newItems[parentId].items.push(item);
    return newItems;
};
const folderTreeBuilder = (flatItems, parentId, parentIdKey, keyPrefix = null) => {
    const items = flatItems.reduce(itemsForTreeReducer.bind(null, parentIdKey, keyPrefix), {});
    return (0, sortBy_1.default)((0, get_1.default)(items, `${parentId}.items`, []), 'value');
};
const buildFolderTree = (flatItems, parentId = 1) => folderTreeBuilder(flatItems, parentId, 'parentId');
exports.buildFolderTree = buildFolderTree;
const buildSbFoldersTree = (flatItems, parentId = 1) => folderTreeBuilder(flatItems, parentId, 'parent_id', 'folder_');
exports.buildSbFoldersTree = buildSbFoldersTree;
const getInitialLocationValue = (hasConflictTerms, sb, tree, item, allFolderData, currentFolderLocationId, currentSbLocationId, resourceType) => {
    if (hasConflictTerms && sb) {
        return {};
    }
    const bulkRoot = resourceType === 'bulk' ? ROOT_ID : null;
    const sbFolderId = bulkRoot || (item?.id ? findFolderByResourceId(item.id, resourceType, allFolderData) : currentFolderLocationId);
    let searchedValue;
    searchedValue = item?.sb_id === undefined || resourceType === 'bulk' ? `sb_${currentSbLocationId}` : `sb_${item.sb_id}`;
    if (!currentSbLocationId && !item?.sb_id) {
        searchedValue = PERSONAL_FOLDER_ID;
    }
    if (currentSbLocationId === 0) {
        searchedValue = item.folder_id;
    }
    if (sbFolderId > 0) {
        searchedValue = `folder_${sbFolderId}`;
    }
    let result = tree[0];
    const getTreeItem = (treeItem) => {
        if (treeItem.key === searchedValue) {
            result = treeItem;
            return true;
        }
        return !!treeItem.items && treeItem.items.some(getTreeItem);
    };
    tree.some(getTreeItem);
    return result;
};
exports.getInitialLocationValue = getInitialLocationValue;
const getSBFoldersNavList = (sbId, locationChanged, location, getFolderId, selectedFolderId, folderData, allFolderData, successBlocs) => {
    let sBlocDisplayName = '';
    let navListOptions = { rootId: ROOT_ID, parentIdName: 'parent_id' };
    const sBloc = successBlocs.find((s) => s.id === sbId);
    if (sBloc) {
        sBlocDisplayName = !locationChanged && location.key === 0 ? 'My Personal Folder' : (sBloc && sBloc.display_name) || '';
        navListOptions = {
            rootId: sBloc.id === 0 ? 0 : ROOT_ID,
            parentIdName: sBloc.id === 0 ? 'parentId' : 'parent_id',
        };
    }
    let currentFolderId = getFolderId(selectedFolderId, location, locationChanged);
    if (sbId === 0 && location.key > 1) {
        currentFolderId = location.key;
    }
    const foldersNavList = currentFolderId > 0 || sbId === 0
        ? getFoldersNavList(sbId === 0 ? folderData : allFolderData, currentFolderId, [], navListOptions)
        : [];
    return { sb: sBlocDisplayName, folders: foldersNavList };
};
exports.getSBFoldersNavList = getSBFoldersNavList;
const isResourceCopiedNameExist = (name, allResourcesType, sbLocationId, action, itemId, locationKey) => allResourcesType.some((resource) => {
    const isSameName = resource.name.trim().toLowerCase() === name.trim().toLowerCase();
    const isSbLocation = sbLocationId === resource.sb_id;
    const isGlobalSb = sbLocationId === '0' && !resource.sb_id;
    const isValidAction = action === 'Copy' || (action === 'Move' && itemId !== resource.id);
    return isSameName && (isSbLocation || (isGlobalSb && resource.folder_id === locationKey)) && isValidAction;
});
exports.isResourceCopiedNameExist = isResourceCopiedNameExist;
const getUniqueName = (name, allResourcesType, sbId, action, itemId, locationKey) => {
    let nameOption = name;
    let availableIndex = 0;
    while (isResourceCopiedNameExist(nameOption, allResourcesType, sbId, action, itemId, locationKey)) {
        availableIndex += 1;
        nameOption = `${name}_${availableIndex}`;
    }
    return nameOption;
};
exports.getUniqueName = getUniqueName;
const getSelectedFolderTree = (allFolders, currentFolderId, isGlobal, sbTab) => {
    const foldersReducer = (folders, currentFolder) => (currentFolder.tab === sbTab ? { ...folders, [currentFolder.id]: currentFolder } : folders);
    const sbTabFolders = allFolders.reduce(foldersReducer, {});
    const rootId = isGlobal ? 1 : 'root';
    const parentIdKey = isGlobal ? 'parentId' : 'parent_id';
    const relevantFolders = [sbTabFolders[currentFolderId]];
    let currentFolder = relevantFolders[0];
    while (currentFolder[parentIdKey] !== rootId) {
        currentFolder = sbTabFolders[currentFolder[parentIdKey]];
        relevantFolders.push(currentFolder);
    }
    return relevantFolders;
};
exports.getSelectedFolderTree = getSelectedFolderTree;
const getCardNamesForBulkCopy = (cards, usedNames) => {
    const appendix = '_copy';
    return cards.reduce((acc, cardItem) => {
        let suggestedName = cardItem.name;
        while (usedNames.has(suggestedName)) {
            suggestedName += appendix;
        }
        acc[cardItem.entity_id] = suggestedName;
        return acc;
    }, {});
};
exports.getCardNamesForBulkCopy = getCardNamesForBulkCopy;
// Those are from folder utils!
const checkUserPermission = (action, resource, permissionManifest) => {
    const permissions = permissionManifest || {};
    const permResource = permissions[resource] || {};
    return permResource[action] || false;
};
exports.checkUserPermission = checkUserPermission;
const getFoldersBySbId = (folders, sbId, sbTab) => folders.filter(({ sb_id, tab }) => sb_id === sbId && tab === sbTab);
exports.getFoldersBySbId = getFoldersBySbId;
const MAX_NAME_LENGTH = 255;
exports.MAX_NAME_LENGTH = MAX_NAME_LENGTH;
//# sourceMappingURL=utils.js.map